import { Stack, styled } from '@mui/material';

import { colors } from '../../components';

export const PaymentsWrapper = styled(Stack)(({ theme }) => ({
    backgroundColor: colors.greyPreset[90],
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    '& .paymentItem': {
        backgroundColor: colors.fullWhite,
        borderRadius: theme.spacing(1.5),
        padding: theme.spacing(1.5),
        gap: theme.spacing(1.5),
    },
}));

export const MakePaymentWrapper = styled(Stack)(({ theme }) => ({
    '& .makePaymentFormWrapper, & .paymentSummaryWrapper': {
        backgroundColor: colors.greyPreset[90],
        borderRadius: theme.spacing(2),
    },
}));
